import React from 'react'
import styles from './styles.css'
import { withRouter, Link } from 'react-router'
import PropTypes from 'prop-types'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import withOrganization from 'App/Decorators/withOrganization'
import { Desktop, Mobile } from 'App/components/Devices'
import Button from 'orionsoft-parts/lib/components/Button'
import autobind from 'autobind-decorator'
import sleep from 'orionsoft-parts/lib/helpers/sleep'

const links = [
  { title: 'Mis documentos', path: '/documents', prop: 'documents' },
  {
    title: 'Sin firmar',
    path: '/documents/ownpendingdocuments',
    prop: 'ownPending'
  },
  { 
    title: 'FEA Sin firmar', 
    path: '/documents/feareadydocuments', 
    prop: 'feaReady'
  },
  {
    title: 'Firmados',
    path: '/documents/ownsigneddocuments',
    prop: 'ownSigned'
  },
  {
    title: 'Firmados por mi',
    path: '/documents/mysigndocuments',
    prop: 'toSign'
  },
  { 
    title: 'Espectador', 
    path: '/documents/viewerdocuments', 
    prop: 'viewer' },
  {
    title: 'Archivados y Rechazados',
    path: '/documents/ownarchiveddocuments',
    prop: 'archived'
  }
]

@withOrganization
@withGraphQL(
  gql`
    query documentCount {
      documentCount
    }
  `
)
@withGraphQL(
  gql`
    query organizationDocCount($organizationId: String) {
      organizationDocCount(organizationId: $organizationId)
    }
  `
)
@withGraphQL(gql`
  query userSignaturesPacks {
    userSignaturesPacks {
        _id
        initDate
        signaturePack {
          name
          simpleSignatures
          advancedSignatures
        }
        simpleSignatures {
          documentId
          signatureId
        }
        advancedSignatures {
          signatureId
        }
    }
  }
`)

@withRouter
export default class Layout extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    children: PropTypes.node,
    documentCount: PropTypes.object,
    organizationDocCount: PropTypes.object,
    organization: PropTypes.object
  }

  state = { open: false }

  componentDidMount() {
    window.addEventListener('mouseup', this.closeMenu, false)
  }

  componentWillUnmount() {
    window.removeEventListener('mouseup', this.closeMenu)
  }

  @autobind
  async closeMenu(event) {
    if (!this.state.open) return true
    await sleep(100)
    this.setState({ open: false })
  }

  @autobind
  toggleMenu() {
    this.setState({ open: !this.state.open })
  }
  renderLinks() {
    //if (!this.props.organization._id) {
      if (this.props.documentCount) {
        //console.log("Tengo documentoCount", this.props.documentCount);
        return links.map((link, index) => {
          const isActive = this.props.router.location.pathname === link.path
          return (
            <div key={index}>
              <Desktop>
                <div
                  onClick={link.onClick}
                  className={isActive ? 'active' : ''}
                >
                  <Link to={link.path}>
                    ({this.props.documentCount[link.prop]}) {link.title}
                  </Link>
                </div>
              </Desktop>
              <Mobile>
                <Link to={link.path} className={styles.menuLink}>
                  <span className={isActive ? styles.active : ''}>
                    ({this.props.documentCount[link.prop]}) {link.title}
                  </span>
                </Link>
              </Mobile>
            </div>
          )
        })
      }
    //} 
    /* else {
      if (this.props.organization._id) {
        if (this.props.organizationDocCount) {
          return links.map((link, index) => {
            const isActive = this.props.router.location.pathname === link.path
            return (
              <div
                key={index}
                onClick={link.onClick}
                className={isActive ? 'active' : ''}
              >
                <Link to={link.path}>
                  ({this.props.organizationDocCount[link.prop]}) {link.title}
                </Link>
              </div>
            )
          })
        }
      }
    }  */
  }
  render() {
    return (
      <div className={styles.container}>
        <Desktop>
          <div className="tabs">{this.renderLinks()}</div>
        </Desktop>
        <Mobile>
          <Button
            className={styles.button}
            label="Documentos"
            onClick={this.toggleMenu}
          />
          {this.state.open === true && (
            <div className={styles.menu} key="menu">
              {this.renderLinks()}
            </div>
          )}
        </Mobile>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Layout/index.js